import { useMutation } from "@apollo/client";
import { Form } from "@/shared/components";
import Dialog from "@mui/material/Dialog";
import { InnerCrudFormHeader } from "./InnerCrudFormHeader";

export interface InnerCrudCreateDialogProps<FormData = any> {
  open: boolean;
  onClose: () => void;
  onSubmitSuccess: (data: any) => void;
  createSchema: any;
  createMutation: any;
  createMutationVariables?: any;
  createInitialVariables?: Partial<FormData>;
  texts: {
    createItem: string;
  };
  refetchQueries?: string[];
  metadata?: Record<string, any>;
  paper?: boolean;
}

export function InnerCrudCreateDialog<FormData = any>({
  open,
  onClose,
  onSubmitSuccess,
  createSchema,
  createMutation,
  createMutationVariables,
  createInitialVariables,
  texts,
  refetchQueries,
  metadata,
  paper = true,
}: InnerCrudCreateDialogProps<FormData>) {
  const [createItem, { loading }] = useMutation(createMutation, {
    refetchQueries,
  });

  const onSubmit = (input: Record<string, any>) => {
    let defaultVariables = createMutationVariables;
    if (typeof defaultVariables === "function") {
      defaultVariables = defaultVariables();
    }
    return createItem({
      variables: {
        input: {
          ...input,
          ...(defaultVariables?.input || {}),
        },
      },
    });
  };

  return (
    <Dialog open={open} onClose={onClose} fullScreen fullWidth>
      <Form
        indent
        initialValues={Object.assign({}, createInitialVariables)}
        schema={createSchema}
        onSubmit={onSubmit}
        onSubmitSuccess={onSubmitSuccess}
        submitButton={false}
        resetButton={false}
        metadata={metadata}
        paper={paper}
        header={(props: any) => (
          <InnerCrudFormHeader
            {...props}
            onClickBack={onClose}
            title={texts.createItem}
            disabled={loading}
          />
        )}
      />
    </Dialog>
  );
}
